document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.querySelector('menu-drawer');
  
  if (!menuDrawer) return;
  
  // Target Dawn's submenu structure
  const submenuButtons = menuDrawer.querySelectorAll('.menu-drawer__menu-item button[aria-expanded]');
  
  submenuButtons.forEach(button => {
    const parentItem = button.closest('.menu-drawer__menu-item');
    const submenu = parentItem.querySelector('.menu-drawer__submenu');
    
    if (submenu) {
      // Create back button
      const backButton = document.createElement('button');
      backButton.className = 'menu-drawer__back-button';
      backButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M10 13L5 8l5-5"/></svg> Back';
      backButton.type = 'button';
      
      // Insert at top of submenu list
      const submenuList = submenu.querySelector('ul');
      if (submenuList) {
        const backItem = document.createElement('li');
        backItem.appendChild(backButton);
        submenuList.insertBefore(backItem, submenuList.firstChild);
        
        // Back button click handler
        backButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          button.click(); // Toggle the submenu closed
        });
      }
    }
  });
});
